import React from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import { API_FORM } from "../../../api"
import Thumbnail from "./Thumbnail"
import "./UploadPaymentField.css"

class UploadPaymentField extends React.Component {
  state = {
    uploading: false,
    hash: Date.now()
  }

  active = false

  componentDidMount() {
    this.active = true
  }

  componentWillUnmount() {
    this.active = false
  }

  render() {
    const {
      field: { name, value },
      form: { values, setFieldValue },
      source
    } = this.props
    return (
      <span className="UploadPaymentField">
        <Dropzone
          className="drop-zone"
          accept="image/*"
          onChange={this.props.onChange}
          multiple={false}
          maxSize={2097152}
          onDrop={async acceptedFiles => {
            // do nothing if no files
            if (acceptedFiles.length === 0) {
              return
            }
            // on drop we add to the existing files
            this.setState({ uploading: true })
            try {
              const formData = new FormData()
              formData.append("image", acceptedFiles[0])
              formData.append("source", source)
              formData.append("photo_url", values[name] || "")
              const newPhoto = await API_FORM.post("/images/upload", formData)
              this.setState({ hash: Date.now() })
              newPhoto && setFieldValue(name, newPhoto.data.url)
            } catch (error) {
              console.log("Photo Upload Error: ", error.response || error)
            } finally {
              this.active && this.setState({ uploading: false })
              console.log(acceptedFiles[0].path)
            }
          }}
          onDropRejected={() => {
            console.log("Drop rejected.")
          }}
        >
          {() => {
            return (
              <div className="drop-zone-place">
                <div className="drop-zone-placeholder">
                  <span
                    className={`drop-zone-placeholder-field ${
                      value ? "invisible" : ""
                    }`}
                  />
                  <span className="button">
                    {!value ? "Choose File" : "Change File"}
                  </span>
                </div>
                {this.state.uploading && <div>Uploading....</div>}
                {!this.state.uploading &&
                  value && <Thumbnail url={`${value}?${this.state.hash}`} />}
              </div>
            )
          }}
        </Dropzone>
      </span>
    )
  }
}

UploadPaymentField.propTypes = {
  source: PropTypes.string.isRequired
}

export default UploadPaymentField
